module.exports = __webpack_public_path__ + "img/SettingsPage.72d1cd1f.png";